import moment from "moment";
import { isPendingOrCompleted } from "./documentUtils";

export type ValidateFunc = () => boolean | Promise<boolean>;

export const getHasOutstandingBalance = (invoice: server.dto.InvoiceForList) => {
  if (!isPendingOrCompleted(invoice.lifeCycle.value)) return false;
  if (invoice.totalOutstanding == null) return false;

  return invoice.totalOutstanding.amount !== 0;
};

export const isInvoiceOverdue = (invoiceDate: Date, dueInDays: number, lifeCycle: server.dto.DocumentLifeCycles) => {
  const dueDate = getInvoiceDueDate(moment.utc(invoiceDate), dueInDays);
  const isOverdue = moment.utc().isAfter(dueDate);
  return isOverdue && lifeCycle === "pending";
};

export const getOverdueDaysCount = (invoiceDate: Date, dueInDays: number): number => {
  const dueDate = getInvoiceDueDate(moment.utc(invoiceDate), dueInDays);
  const today = moment.utc();
  if (today.isSameOrBefore(dueDate)) return 0;
  return today.diff(dueDate, "days");
}

export const getInvoiceDueDate = (sendDate: moment.Moment | Date, daysAfterSend: number): moment.Moment => {
  return moment.utc(sendDate).add(daysAfterSend, "days");
}
